/**
 * 深度克隆
 * @param {*} obj 
 * @returns 
 */
var deepClone = function(obj) {
	return new Promise((resolve) => {
		const {port1,port2} = new MessageChannel();
		port1.postMessage(obj);
		port2.onmessage = (msg) => {
			resolve(msg.data)
		}
	})
}

export default {deepClone};